/**
 * Checks if a given value is considered empty.
 *
 * A value is considered empty if it is `undefined`, `null`, or an empty string (`""`).
 *
 * @param value - The value to check for emptiness.
 * @returns `true` if the value is empty; otherwise, `false`.
 */
export function isEmptyField(value: unknown): boolean {
  return value === undefined || value === null || value === "";
}
